import axios from '@/axiosInstance.ts'
import axiosNode from '@/axiosInstanceNode.ts'
import {LOCAL_STORAGE_AIRBNB_ACCESS_TOKEN} from '../constants'

/* Login */
interface HttpLoginOptions {
    payload: {
        email: string
        password: string
    }
}
export const httpLogin = ({payload}: HttpLoginOptions) => axios.post('login', payload)

/*Logout*/
export const httpLogout = () => axios.get('logout')

/*Me — canonical user from the Node backend (replaces legacy PHP /navigate/showUser)*/
export const httpMe = () => axiosNode.get('/v3/navigate/photographers/me')

/*Forgot password*/
interface HttpForgotPasswordOptions {
    payload: {
        email: string
    }
}
export const httpForgotPassword = ({payload}: HttpForgotPasswordOptions) => {
    return axios.post('/password/email', payload)
}

/*Check recovery password token*/
export interface HttpCheckRecoverPasswordTokenOptions {
    urlParams: {
        token: string
    }
}
export const httpCheckResetPasswordToken = ({urlParams}: HttpCheckRecoverPasswordTokenOptions) => {
    return axios.get(`/password/recovery/${urlParams.token}`)
}

/*Reset password*/
export interface HttpResetPasswordOptions {
    payload: {
        password: string
    }
    urlParams: {
        token: string
    }
}
export const httpResetPassword = ({payload, urlParams}: HttpResetPasswordOptions) => {
    return axios.post(`/password/${urlParams.token}/change`, payload)
}

/*Check create account token*/
export interface HttpCheckCreateAccountTokenOptions {
    urlParams: {
        token: string
    }
}
export const httpCheckCreateAccountToken = ({urlParams}: HttpCheckCreateAccountTokenOptions) => {
    return axios.get(`/validate/photographer/${urlParams.token}`)
}

/*Create account*/
export interface HttpCreateAccountOptions {
    payload: {
        password: string
        password_confirmation: string
    }
    urlParams: {
        token: string
    }
}
export const httpCreateAccount = ({payload, urlParams}: HttpCreateAccountOptions) => {
    return axios.post(`/validate/photographer/${urlParams.token}`, payload)
}

/*Change password*/
export interface HttpChangePasswordOptions {
    payload: {
        current_password: string
        new_password: string
        password_confirmation: string
    }
}
export const httpChangePassword = ({payload}: HttpChangePasswordOptions) => {
    return axios.post(`/user/change-password`, payload)
}

/*Send rating*/
export interface HttpSendRating {
    payload: {
        section: 'Assignment Page - July 2024' | 'Payment Section - July 2023'
        rating: number
    }
}
export const httpSendRating = ({payload}: HttpSendRating) => axios.post('rate', payload)

export const httpPhotographersSsoConfigured = () =>
    axios.put('/photographers/sso-configured', undefined, {
        headers: {'x-oauth-token': localStorage.getItem(LOCAL_STORAGE_AIRBNB_ACCESS_TOKEN)}
    })

export const httpPhotographersSsoLogout = () => axios.post('photographers/oauth/logout')

interface HttpPhotographersSsoLoginOptions {
    payload: {
        code: string
    }
}

export const httpPhotographersSsoLogin = ({payload}: HttpPhotographersSsoLoginOptions) =>
    axios.post('/photographers/oauth/login', payload)

export const httpPhotographersMe = () =>
    axios.get('/photographers/user-me', {
        headers: {
            'x-oauth-token': localStorage.getItem(LOCAL_STORAGE_AIRBNB_ACCESS_TOKEN)
        }
    })
